import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/sepak.png'


const _withScopeId = n => (_pushScopeId("data-v-7bd6982a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", {
  id: "landing",
  class: "h-[36rem] w-full"
}, null, -1))
const _hoisted_3 = {
  id: "product",
  class: "pt-5 pb-16 core-container"
}
const _hoisted_4 = { class: "flex justify-between items-end my-10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-2xl text-primary" }, "Featuring Products", -1))
const _hoisted_6 = { class: "mb-10" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-6 gap-y-12 md:grid-cols-3 md:gap-12 md:gap-y-24 xl:grid-cols-4 xl:gap-20 xl:gap-y-24" }
const _hoisted_8 = {
  id: "about",
  class: "core-container"
}
const _hoisted_9 = { class: "flex flex-col-reverse justify-evenly items-center xl:flex-row" }
const _hoisted_10 = { class: "max-w-[32rem] w-full p-16" }
const _hoisted_11 = { class: "aspect-w-1 aspect-h-1" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "max-w-[32rem] w-full py-10 px-4 flex flex-col justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-6 text-3xl text-primary" }, "About Us"),
  /*#__PURE__*/_createElementVNode("p", { class: "leading-loose text-center" }, " Rohnisc’s Hoodie design to typically worn for casual wear or sportswear, for which people often partner it with sweat pants. The garment is a protective piece of outerwear that is both comfortable and warm with a fitted waistband and cuffs to trap heat. ")
], -1))
const _hoisted_14 = { class: "py-6" }
const _hoisted_15 = { class: "core-container" }
const _hoisted_16 = { class: "flex flex-col justify-center items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aspect-w-16 aspect-h-13" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    loading: "eager"
  })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"max-w-[32rem] px-4 py-6 leading-loose text-center\" data-v-7bd6982a> We are a Khmer handicrafts online platform that bring handicrafts makers and customers together to find the real local made products. </div><div class=\"flex mt-5 mb-24 text-3xl xl:mb-10 text-primary\" data-v-7bd6982a><div class=\"mx-6 cursor-pointer\" data-v-7bd6982a><i class=\"fab fa-facebook\" data-v-7bd6982a></i></div><div class=\"mx-6 cursor-pointer\" data-v-7bd6982a><i class=\"fab fa-instagram\" data-v-7bd6982a></i></div><div class=\"mx-6 cursor-pointer\" data-v-7bd6982a><i class=\"fab fa-telegram\" data-v-7bd6982a></i></div></div>", 2)

import ProductCard from "@/components/common/ProductCard.vue";

import { useFetchProducts } from "@/composables/use-fetch-products";
import { loadingWrapper } from "@/helpers/loading-wrapper";
import { scrollTop } from "@/helpers/scroll-top";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { products, refetchProducts } = useFetchProducts();

const search = ref("");

watch(search, () => {
  setTimeout(() => {
    loadingWrapper(async () => {
      refetchProducts({
        name: search.value,
      });
    });
  }, 750);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/browse')))
        }, " See More ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          id: "search",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
          type: "text",
          class: "block mt-1 w-full rounded-sm border-gray-400 shadow-sm sm:text-sm focus:ring-primary focus:border-primary",
          placeholder: "Search"
        }, null, 512), [
          [_vModelText, search.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product) => {
          return (_openBlock(), _createBlock(ProductCard, {
            key: product.id,
            product: product
          }, null, 8, ["product"]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: require('../assets/images/about-us.jpg')
            }, null, 8, _hoisted_12)
          ])
        ]),
        _hoisted_13
      ])
    ]),
    _createElementVNode("footer", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "py-6 w-14 cursor-pointer",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scrollTop) && _unref(scrollTop)(...args)))
          }, _hoisted_18),
          _hoisted_19
        ])
      ])
    ])
  ]))
}
}

})